/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DefaultStatusSelector/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaSelectOne from 'DesignSystem/TysiaSelectOne/index'
import TysiaSelectOneArrow from 'DesignSystem/TysiaSelectOne/TysiaSelectOneArrow/index'
import TysiaSelectOneContent from 'DesignSystem/TysiaSelectOne/TysiaSelectOneContent/index'
import TysiaSelectOneInput from 'DesignSystem/TysiaSelectOne/TysiaSelectOneInput/index'
import TysiaSelectOneOptions from 'DesignSystem/TysiaSelectOne/TysiaSelectOneOptions/index'
import TysiaSelectOnePopover from 'DesignSystem/TysiaSelectOne/TysiaSelectOnePopover/index'



/** @type {import('Simple/types.js').View} */
export default function DefaultStatusSelector({
  children,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/EventAction/Content/Content/Content/StatusUpdate/Content/Manual/DefaultStatusSelector",
  onChange
  
}) {
let statusesValueData = fromData.useDataValue({ viewPath,
context: 'statuses',
})
let eventActionDataIsSubsetValueData = fromData.useDataValue({ viewPath,
context: 'event_action',
path: 'data.is_subset',
})
let eventActionDataSubsetStatusesValueData = fromData.useDataValue({ viewPath,
context: 'event_action',
path: 'data.subset_statuses',
})
let aggregateData = fromHelpers.getOptions(statusesValueData, eventActionDataIsSubsetValueData, eventActionDataSubsetStatusesValueData)
let eventActionDataDefaultStatusValueData = fromData.useDataValue({ viewPath,
context: 'event_action',
path: 'data.default_status',
})
let eventActionDataDefaultStatusChangeData = fromData.useDataChange({ viewPath,
context: 'event_action',
path: 'data.default_status',
})
let eventActionDataHasDefaultStatusValueData = fromData.useDataFormat({ viewPath,
context: 'event_action',
path: 'data.has_default_status',
format: fromFormat.not,
})
  return (<React.Fragment
>
<TysiaSelectOne
  viewPath={`${viewPath}/TysiaSelectOne`}
 flexGrow={0}
 maxWidth={250}
 size="small"
 id="type"
 data="statuses"
 data="event_action.data.is_subset"
 data="event_action.data.subset_statuses"
 aggregate="helpers.js getOptions"
 from={aggregateData}
 data="event_action.data.default_status"
 value={eventActionDataDefaultStatusValueData}
 onChange={eventActionDataDefaultStatusChangeData}
 data="event_action.data.has_default_status"
 format="/Data/format.js not"
 disabled={eventActionDataHasDefaultStatusValueData}
>
{childProps => (
<TysiaSelectOneContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneContent`}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneInput
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneInput`}
/>
<TysiaSelectOneArrow
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneArrow`}
/>
<TysiaSelectOnePopover
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOnePopover`}
>
{childProps => (
<TysiaSelectOneOptions
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneOptions`}
/>
)}
</TysiaSelectOnePopover>
</React.Fragment>
)}
</TysiaSelectOneContent>
)}
</TysiaSelectOne>
{children}
</React.Fragment>)
}